import React from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";

function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-right" aria-hidden="true"/>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <i className="fal fa-chevron-left" aria-hidden="true"/>
        </div>
    );
}

class Slideshow extends React.Component {
    static defaultProps = {
        slides: []
    };

    static propTypes = {
        slides: Proptypes.array
    };

    createMarkup = (html) => {
        return {
            __html: html
        };
    }

    render() {
        const settings = {
            dots: true,
            adaptiveHeight: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            autoplay: true,
            speed: 1500
        };

        return (
            <Slider {...settings}>
                {this.props.slides.map((slide, index) => {
                    return (
                        <div key={index} className="slide side-content">
                            <div className="heroWrapper">
                                <div className="hero">
                                    <div className="heroContent">
                                        <a className="cover" href={slide.targetURL} alt="Go to featured hero article" title={slide.name} />
                                        <div className="heroImg">
                                            {slide.content.sourceTagData && slide.content.imageTagData && <picture>
                                                {
                                                    slide.content.sourceTagData.map((data, index) => {
                                                        return (
                                                            <source key={index} media={data.media} srcSet={data.srcset} type={data.type} />
                                                        );
                                                    })
                                                }
                                                <img className={slide.content.imageTagData.class} src={slide.content.imageTagData.src} alt={slide.content.imageTagData.alt} title={slide.content.imageTagData.title}></img>
                                            </picture>}
                                        </div>
                                        <div className="main-container">
                                            <div className="heroInfo">
                                                <a href={slide.targetURL} alt="Go to featured hero article" title={slide.name} />
                                                <div className="h1 text-shadow max-2-lines l-h-3" dangerouslySetInnerHTML={this.createMarkup(slide.name)} />
                                                <div className="max-2-lines l-h-3 p" dangerouslySetInnerHTML={this.createMarkup(slide.summary)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="heroInfoSide">
                                <a href={slide.targetURL} alt="Go to featured hero article" title={slide.name}>
                                    <div className="h2 bolder max-3-lines l-h-3 m-b-0" dangerouslySetInnerHTML={this.createMarkup(slide.name)} />
                                </a>
                                <div className="l-h-3 p" dangerouslySetInnerHTML={this.createMarkup(slide.summary)} />
                            </div>
                            <div className="heroInfoMobile">
                                <a href={slide.targetURL} alt="Go to featured hero article" title={slide.name} />
                                <div className="h1 text-shadow max-2-lines l-h-3" dangerouslySetInnerHTML={this.createMarkup(slide.name)} />
                                <div className="h1 text-shadow max-3-lines l-h-3" dangerouslySetInnerHTML={this.createMarkup(slide.name)} />
                                <div className="max-2-lines l-h-3 p" dangerouslySetInnerHTML={this.createMarkup(slide.summary)} />
                                <div className="max-3-lines l-h-3 p" dangerouslySetInnerHTML={this.createMarkup(slide.summary)} />
                            </div>
                        </div>
                    );
                })}
            </Slider>
        );
    }
}

export default Slideshow;
